<!-- @format -->

<delivery-search-modal>
  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
    on-before-show="{ onBeforeShow }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <h2 class="heading-01 heading_search">検索条件設定</h2>
        <form class="" name="form01">
          <div class="container_input">
            <div class="wrap_input wrap_input-30">
              <label class="form-heading" for="delivery_number">納品番号</label>
              <input
                id="delivery_number"
                class="text_input"
                type="text"
                name="id"
                is="binding"
                data="{ state.params }"
                placeholder="000000"
              />
            </div>
            <!--/.wrap_input-->

            <div class="wrap_input wrap_input-30">
              <label class="form-heading" for="order_id">注文ID</label>
              <input
                id="order_id"
                class="text_input"
                type="text"
                name="order_id"
                is="binding"
                data="{ state.params }"
                placeholder="000000"
              />
            </div>
            <!--/.wrap_input-->
          </div>
          <!--/.container_input-->

          <div class="container_input">
            <div class="wrap_input wrap_input-50">
              <label class="form-heading" for="delivery_date">納品日</label>
              <div class="modal_input_container">
                <div class="modal_input_box">
                  <input
                    type="text"
                    id="day_start"
                    name="range_start"
                    is="binding"
                    data="{ state.params }"
                    class="text_input input_calendar"
                  />
                </div>
                <!--/.modal_input_box-->
                <div class="modal_input-dash">〜</div>
                <div class="modal_input_box">
                  <input
                    type="text"
                    id="day_end"
                    name="range_end"
                    is="binding"
                    data="{ state.params }"
                    class="text_input input_calendar"
                  />
                </div>
                <!--/.modal_input_box-->
              </div>
              <!--/.modal_input_container-->
            </div>
            <!--/.wrap_input-->
          </div>
          <!--/.container_input-->
        </form>
        <div class="container_button">
          <button
            class="button button-clear js-modal-close"
            type="button"
            value="キャンセル"
            onclick="{ props.onClose }"
          >
            キャンセル
          </button>
          <button
            class="button button-primary button-primary-mini"
            type="button"
            value="検索"
            onclick="{ onSearch }"
          >
            検索
          </button>
        </div>
        <!--/.container_button-->
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->

  <script>
    import base from "../modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      },
      ParamNames: {
        id: "納品番号",
        order_id: "注文ID",
        range_start: "納品日開始",
        range_end: "納品日終了",
      },
      state: {
        params: {},
      },
      onBeforeMount(props, state) {
        state.params = Object.keys(this.ParamNames).reduce((a, name) => {
          a[name] = "";
          return a;
        }, {});
      },
      onMounted(props, state) {
        window.$(".input_calendar").flatpickr({
          locale: "ja",
        });
      },
      onBeforeShow() {
        this.update({
          params: Object.keys(this.ParamNames).reduce((a, name) => {
            a[name] = this.props.params[name] ? this.props.params[name] : "";
            return a;
          }, {}),
        });
      },
      onSearch(e) {
        const tags = Object.entries(this.state.params).reduce(
          (a, [name, value]) => {
            if (value) {
              a.push({ name, label: this.ParamNames[name], value });
            }
            return a;
          },
          []
        );
        this.props.onSearch(this.state.params, tags);
      },
    };
  </script>
</delivery-search-modal>
